import React, { useState, useEffect } from 'react';
import '../../styles//crud.css';
import '../../styles//botones_dflt.css';
import Spinner from "../spinner";
import {ip_back , api_key} from '../../constants/appConstants';

const CrudTable = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]); // Estado para almacenar filas
  const [formData, setFormData] = useState({ usuario: '', rol: '' }); // Estado del formulario
  const [isFormModalOpen, setIsFormModalOpen] = useState(false); // Control del modal de ingreso/edición
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Control del modal de eliminación
  const [deleteIndex, setDeleteIndex] = useState(null); // Índice de la fila a eliminar
  const [rolDropdownOptions, setRolDropdownOptions] = useState([]);
  const [usrDropdownOptions, setUsrDropdownOptions] = useState([]);
  const API_USRS = ip_back + '/api/usuarios/obtener';
  const API_ROLES_USRS = ip_back + '/api/usuarios/roles_usuario';
  const API_ROLES = ip_back + '/api/usuarios/roles';

    // Cargar datos desde la API al montar el componente
  const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(API_USRS, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
        });
        const json = await response.json();
        const allData = [];
        const usuarios = json.usuarios.map((user) => user.usuario);

        for (const usuario_aux of usuarios){
          const response = await fetch(API_ROLES_USRS, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-api-key': api_key,
            Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ "usuario" : usuario_aux})
          });
          const json_usrs = await response.json();
          const user_roles = json_usrs.roles.map((item) => ({
            usuario: json_usrs.usuario,
            rol: item.nombre
          }));
          allData.push(...user_roles)
        }
        setData(allData);
        setLoading(false);
      } catch (error) {
        console.error('Error al cargar los datos:', error);
      }
  };

  const fetchDataRolOptions = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(API_ROLES, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
            Authorization: `Bearer ${token}`
        },
      });
      const json = await response.json();
      setRolDropdownOptions(json);
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    }
  };

  const fetchDataUsrsOptions = async () => {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const response = await fetch(API_USRS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': api_key,
            Authorization: `Bearer ${token}`
        },
      });
      const json = await response.json();
      setUsrDropdownOptions(json);
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    }
  };

  const storedUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    fetchData();
    fetchDataRolOptions();
    fetchDataUsrsOptions();
  }, []); // Solo se ejecuta al montar el componente

  // Manejar los cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Abrir el modal de formulario para agregar o editar
  const openFormModal = (index = null) => {
    if(index == null){
      setFormData({ usuario: '', rol: '' }); // Restablecer datos para nuevo ingreso
      setIsFormModalOpen(true);
    }
  };

  // Cerrar el modal de formulario
  const closeFormModal = () => {
    fetchData();
    setIsFormModalOpen(false);
  };

  // Guardar datos (Agregar o Editar)
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    var API_URL = '';
    const select_rol = rolDropdownOptions.roles.find((opt) => opt.nombre === formData.rol)?.id;
    const select_user = usrDropdownOptions.usuarios.find((opt) => opt.usuario === formData.usuario)?.usuario;

    API_URL = ip_back + '/api/usuarios/asignar_rol';
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "usuario" : select_user, "creador" : storedUser ,"rol" : select_rol}),
        });
  
        if (response.ok) {
          setIsFormModalOpen(false); // Cierra el modal
        } else {
          console.error('Error al crear nuevo usuario:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    closeFormModal();
  };

  // Abrir el modal de confirmación de eliminación
  const openDeleteModal = (index) => {
    setDeleteIndex(index);
    setIsDeleteModalOpen(true);
  };

  // Cerrar el modal de confirmación de eliminación
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  // Confirmar eliminación
  const confirmDelete = async () => {
  var  API_URL = ip_back + '/api/usuarios/quitar_rol';
  var del_user=data.at(deleteIndex).usuario;
  var del_rol=rolDropdownOptions.roles.find((opt) => opt.nombre ===data.at(deleteIndex).rol)?.id;
      try {
        const token = JSON.parse(localStorage.getItem("token"));
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({ "usuario" : del_user,"rol" : del_rol}),
        });
  
        if (response.ok) {
          setIsFormModalOpen(false); // Cierra el modal
        } else {
          console.error('Error al eliminar el rol:', response.statusText);
        }
      } catch (error) {
        console.error('Error al hacer la solicitud:', error);
      }
    fetchData();
    closeDeleteModal();
  };

  return (
    <div className="crud-table">
      
      {!loading && <button className='button_new' onClick={() => openFormModal()} >Asignar Rol a Usuario</button>}
      {/* Tabla */}
      {loading ? <Spinner /> :
        <table>
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Rol</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  <td>{item.usuario}</td>
                  <td>{item.rol}</td>
                  <td>
                    <button className="eliminar" onClick={() => openDeleteModal(index)}>Eliminar</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No hay datos</td>
              </tr>
            )}
          </tbody>
        </table>
      }

      {/* Modal de Formulario */}
      {isFormModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Añadir Rol</h2>
            <form onSubmit={handleFormSubmit} className='form_crud'>
              <select id="options"
                type="text"
                name="usuario"
                placeholder="Nombre Usuario"
                value={formData.usuario}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  -- Selecciona un Usuario --
                </option>
                {usrDropdownOptions.usuarios.map((option) => (
                <option key={option.usuario} value={option.usuario}>
                  {option.usuario}
                </option>
                ))}
              </select>

              <select id="options"
                type="text"
                name="rol"
                placeholder="Rol"
                value={formData.rol}
                onChange={handleChange}
                required
              >
                <option value="" disabled>
                  -- Selecciona un Rol --
                </option>
                {rolDropdownOptions.roles.map((option) => (
                <option key={option.id} value={option.nombre}>
                  {option.nombre}
                </option>
                ))}
              </select>
              <button type="submit" className='guardar'>Asignar Rol</button>
              <button type="button" className='cancelar' onClick={closeFormModal}>Cancelar</button>
            </form>
          </div>
        </div>
      )}

      {/* Modal de Confirmación de Eliminación */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmar Eliminación</h2>
            <p>¿Estás seguro de que deseas eliminar este registro?</p>
            <button onClick={confirmDelete}>Sí, eliminar</button>
            <button onClick={closeDeleteModal}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CrudTable;